import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    // if user is not authenticated, navigate to login page
    return <Navigate to="/" />;
  }
  return children;
};
export default ProtectedRoute;
